"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _generalStore = require("general-store");

var _immutable = require("immutable");

var _PortalStore = _interopRequireDefault(require("crm_data/portal/PortalStore"));

var _ProfileSequencesModal = _interopRequireDefault(require("crm_ui/profile/modals/ProfileSequencesModal"));

var _react = _interopRequireWildcard(require("react"));

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _UserStore = _interopRequireDefault(require("crm_data/user/UserStore"));

var dependencies = {
  subject: _SubjectDependency.default,
  user: {
    stores: [_UserStore.default],
    deref: function deref() {
      var user = _UserStore.default.get();

      return user && (0, _immutable.fromJS)(user);
    }
  },
  portal: {
    stores: [_PortalStore.default],
    deref: function deref() {
      var portal = _PortalStore.default.get();

      return portal && (0, _immutable.fromJS)(portal);
    }
  }
};

var ProfileSequencesModalConnector =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ProfileSequencesModalConnector, _Component);

  function ProfileSequencesModalConnector() {
    (0, _classCallCheck2.default)(this, ProfileSequencesModalConnector);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProfileSequencesModalConnector).apply(this, arguments));
  }

  (0, _createClass2.default)(ProfileSequencesModalConnector, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_ProfileSequencesModal.default, this.props);
    }
  }]);
  return ProfileSequencesModalConnector;
}(_react.Component);

var _default = (0, _generalStore.connect)(dependencies)(ProfileSequencesModalConnector);

exports.default = _default;
module.exports = exports.default;